import {Directive, ElementRef, HostBinding, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appImageSelect]'
})
export class ImageSelectDirective {
  @Input() type;
  constructor(public el: ElementRef) { }

  @HostListener('click')
  clickButton() {
    console.log(this.type);
    if (this.type === 'images') {
      document.querySelectorAll('.small_image_list_item img').forEach((item: HTMLElement) => {
        item.style.border = 'none';
      });
      this.el.nativeElement.style.border = '3px solid #00BFFF';
    } else {
      document.querySelectorAll('.small_image_list_item video').forEach((item: HTMLElement) => {
        item.style.border = 'none';
      });
      this.el.nativeElement.style.border = '3px solid #00BFFF';
      console.log(this.el);
    }

  }
}
